module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag46_2228AT.8ec1f061.jpg";